@use "../../sass/variables/colors";

.ux-popover-menu {
  display: inline-block;
  position: relative;

  .ux-popover-panel {
    padding: 0 20px;
  }

  &__top-start,
  &__bottom-start {
    .ux-popover__container {
      transform: translate(var(--ux-popover-menu-content-offset-start), 0);
    }
  }

  &__top-end,
  &__bottom-end {
    .ux-popover__container {
      transform: translate(var(--ux-popover-menu-content-offset-end), 0);
    }
  }

  &__left-start,
  &__right-start {
    .ux-popover__container {
      transform: translate(0, var(--ux-popover-menu-content-offset-start));
    }
  }

  &__left-end,
  &__right-end {
    .ux-popover__container {
      transform: translate(0, var(--ux-popover-menu-content-offset-end));
    }
  }
}

.ux-popover-menu__toggle {
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 40px;
  position: relative;
  width: 40px;

  span {
    background: #000;
    border-radius: 100%;
    height: 3px;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 3px;

    &::before,
    &::after {
      background: colors.$color-black;
      border-radius: 100%;
      content: "";
      height: 3px;
      left: 50%;
      position: absolute;
      transform: translate(-50%, 0);
      width: 3px;
    }

    &::before {
      top: -6px;
    }

    &::after {
      top: 6px;
    }
  }
}

.ux-popover-menu__content {
  min-width: 300px;
  padding: var(--ux-popover-menu-content-padding);

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  li {
    border-bottom: 1px solid var(--ux-popover-menu-border-color);
    cursor: pointer;
    padding: var(--ux-popover-menu-item-padding);
    text-align: left;

    &:last-child {
      border-bottom: 0;
    }
  }
}
